import { useEffect, useState, useCallback } from "react";
import { useAuth } from "@/context/AuthContext";
import api, { apiError, downloadUrl } from "@/lib/api";
import DocumentUpload from "@/components/DocumentUpload";
import { EmptyState } from "@/components/ui/bits";
import { FileText, Download, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function ClientDocuments() {
  const { user } = useAuth();
  const [docs, setDocs] = useState([]);
  const clientId = user.client_id;

  const load = useCallback(() => api.get(`/documents?client_id=${clientId}`).then(({ data }) => setDocs(data)).catch((e) => toast.error(apiError(e))), [clientId]);
  useEffect(() => { load(); }, [load]);

  const del = async (id) => { try { await api.delete(`/documents/${id}`); load(); toast.success("Removed"); } catch (e) { toast.error(apiError(e)); } };

  return (
    <div>
      <h1 className="font-serif font-bold text-3xl text-white mb-1">Documents</h1>
      <p className="text-slate-400 mb-5">Upload your paperwork securely — we'll take it from here.</p>
      <div className="mb-6"><DocumentUpload clientId={clientId} category="document" onUploaded={load} /></div>
      {docs.length === 0 ? <EmptyState icon={FileText} title="No documents yet" hint="Drag in a PDF, photo or spreadsheet to get started." /> : (
        <div className="space-y-2">
          {docs.map((d) => (
            <div key={d.id} className="card-surface rounded-xl p-3 flex items-center justify-between gap-3">
              <div className="min-w-0 flex items-center gap-3">
                <FileText className="text-[#C9A84A] shrink-0" size={20} />
                <div className="min-w-0">
                  <div className="text-white text-sm truncate">{d.original_filename}</div>
                  <div className="text-slate-500 text-xs">{(d.size / 1024).toFixed(0)} KB · {d.uploaded_by_role === "client" ? "You" : "JTS Swanson"}{d.category === "report" ? " · report" : ""}</div>
                </div>
              </div>
              <div className="flex items-center gap-1 shrink-0">
                <a href={downloadUrl(`documents/${d.id}/download`)} target="_blank" rel="noreferrer" className="text-slate-400 hover:text-white p-2"><Download size={18} /></a>
                {d.uploaded_by === user.id && <button onClick={() => del(d.id)} className="text-slate-400 hover:text-red-400 p-2"><Trash2 size={18} /></button>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
